// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report__body[data-v-7a7bc43c] {\n  white-space: pre-wrap;\n  font-size: 1.2em;\n}\n.btn__back[data-v-7a7bc43c] {\n  width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
